const WaveBackground = () => {
  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-background via-ocean-mid to-ocean-surface opacity-80" />
      
      {/* Animated wave layers */}
      <svg
        className="absolute bottom-0 left-0 w-full h-[40vh]"
        viewBox="0 0 1440 320"
        preserveAspectRatio="none"
        style={{ animationDelay: "0s" }}
      >
        <path
          fill="hsl(187 85% 53% / 0.05)"
          d="M0,192L48,197.3C96,203,192,213,288,229.3C384,245,480,267,576,250.7C672,235,768,181,864,181.3C960,181,1056,235,1152,234.7C1248,235,1344,181,1392,154.7L1440,128L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
        />
      </svg>
      
      <svg
        className="absolute bottom-0 left-0 w-full h-[35vh]"
        viewBox="0 0 1440 320"
        preserveAspectRatio="none"
        style={{ animationDelay: "-2s" }}
      >
        <path
          fill="hsl(175 72% 45% / 0.08)"
          d="M0,64L48,80C96,96,192,128,288,128C384,128,480,96,576,90.7C672,85,768,107,864,128C960,149,1056,171,1152,165.3C1248,160,1344,128,1392,112L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
        />
      </svg>
      
      <svg
        className="absolute bottom-0 left-0 w-full h-[30vh]"
        viewBox="0 0 1440 320"
        preserveAspectRatio="none"
        style={{ animationDelay: "-4s" }}
      >
        <path
          fill="hsl(190 100% 70% / 0.03)"
          d="M0,256L48,240C96,224,192,192,288,181.3C384,171,480,181,576,202.7C672,224,768,256,864,261.3C960,267,1056,245,1152,224C1248,203,1344,181,1392,170.7L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
        />
      </svg>
      
      {/* Floating orbs */}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 rounded-full bg-primary/5 blur-3xl" />
      <div className="absolute top-1/2 right-1/4 w-64 h-64 rounded-full bg-accent/5 blur-3xl" style={{ animationDelay: "-3s" }} />
      <div className="absolute bottom-1/4 left-1/2 w-80 h-80 rounded-full bg-cyan-accent/3 blur-3xl" />
    </div>
  );
};

export default WaveBackground;
